import { apiClient, clearStoredTokens, getStoredRefreshToken, storeTokens } from './apiClient';
import { TokenResponse } from '../types/TokenResponse';

export interface LoginPayload {
  email: string;
  password: string;
  tenantSlug?: string;
}

export type TenantAuthMethods = {
  allowEmailPassword: boolean;
  allowGoogle: boolean;
  googleClientId?: string | null;
  googleAllowedDomain?: string | null;
};

export async function fetchAuthMethods(tenantSlug?: string): Promise<TenantAuthMethods> {
  const response = await apiClient.get<TenantAuthMethods>('/v1/auth/methods', {
    params: tenantSlug ? { tenantSlug } : undefined,
  });
  return response.data;
}

export async function login(payload: LoginPayload): Promise<TokenResponse> {
  const response = await apiClient.post<TokenResponse>('/v1/auth/login', payload);
  storeTokens(response.data);
  return response.data;
}

export async function loginWithGoogle(idToken: string, tenantSlug?: string): Promise<TokenResponse> {
  const response = await apiClient.post<TokenResponse>('/v1/auth/google', {
    idToken,
    tenantSlug,
  });
  storeTokens(response.data);
  return response.data;
}

export async function logout(): Promise<void> {
  const refreshToken = getStoredRefreshToken();
  try {
    if (refreshToken) {
      await apiClient.post('/v1/auth/logout', { refreshToken });
    }
  } catch {
    // Encerramento local mesmo se a API estiver offline ou a sessão já tiver expirado.
  } finally {
    clearStoredTokens();
  }
}

export async function requestPasswordReset(email: string): Promise<void> {
  await apiClient.post('/v1/auth/forgot-password', { email });
}

export async function resetPassword(
  token: string,
  newPassword: string,
  confirmNewPassword: string,
): Promise<void> {
  await apiClient.post('/v1/auth/reset-password', {
    token,
    newPassword,
    confirmNewPassword,
  });
}

export async function changePassword(
  currentPassword: string,
  newPassword: string,
  confirmNewPassword: string,
): Promise<void> {
  await apiClient.post('/v1/auth/change-password', {
    currentPassword,
    newPassword,
    confirmNewPassword,
  });
}
